import { useTranslation } from 'react-i18next';

export function AuthDivider() {
  const { t } = useTranslation();

  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t border-border-subtle" />
      </div>
      <div className="relative flex justify-center text-xs">
        <span className="bg-white px-2 font-label uppercase text-brand-secondary/70 dark:bg-background dark:text-muted-foreground">
          {t('auth.linkedin.divider')}
        </span>
      </div>
    </div>
  );
}
